<div class="tiny-mice-editor-host">
    <editor *ngIf="editorConf && editorElementId"
            [init]="editorConf"
            [id]="editorElementId"
            [initialValue]="editorPatchValue || ''"
            (onInit)="onEditorInit($event)"></editor>
</div>

<input (change)="encodeImageFileAsURL($event)" accept=".png, .jpg, .jpeg" id="imageUpload{{getRandom}}" style="display: none" type="file" />
